import React from 'react'
import styles from './dashboard.module.css'
const JobPostUsingTemplateBanner = () => {
    return (
        <React.Fragment>
            <div className='col-md-6'>
                <div className={`${styles['templates-card']}`}>
                    <h3>Use Templates</h3>
                    <p>Pick up the template and save time - Less effort more productivity.</p>
                    <div className={`${styles['temp-two']} ${styles['scroll-row']} row gy-2`}>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-one']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardone-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-two']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardtwo-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-three']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardthree-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-four']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardfour-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-five']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardfive-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 mw-50'>
                            <div className={`${styles['card-six']}`}>
                                <h4>Software Developer</h4>
                                <div className={`${styles['cardsix-data']}`}>
                                    <p><strong>Description:</strong> A...</p>
                                    <p><strong>Job type:</strong> A...</p>
                                    <p><strong>Location:</strong> A...</p>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles['explore-btn']} col-md-12 text-center`}>
                            <a href='#' className={`${styles['exp-btn']} btn`}>Explore more</a>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default JobPostUsingTemplateBanner